<app-layout>
  <div class="main">
    <div class="header">
      <app-titulo>Agendamentos</app-titulo>
      <div class="header-buttons">
        <app-botao
          type="primario"
          class="button"
          text="Novo Agendamento"
          icon="assets/add.svg"
          *ngIf="solicitarAgendamento"
          (click)="navegarAgendamento()"></app-botao>
        <app-botao
          type="secundario"
          class="button"
          text="Exportar Excel"
          icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Solicitações</div>
        <div class="align-button">
          <form [formGroup]="form" (ngModelChange)="getAgendamento()">
            <div class="table-filters">
              <app-input
                label="Placa do Cavalo"
                placeholder="Pesquisar"
                name="TX_PLCA_CAVA"
                formControlName="TX_PLCA_CAVA"
                width="100%"></app-input>
              <app-input
                type="select-table"
                label="Tipo de Serviço"
                width="100%"
                name="FK_SRVC"
                formControlName="FK_SRVC"
                (ngModelChange)="escolherServico($event)"
                [selectData]="servicoOptions"></app-input>
              <app-input
                label="Data Início"
                type="date"
                width="100%"
                class="pesquisa"
                name="DT_AGND_INIC"
                formControlName="DT_AGND_INIC"></app-input>
              <app-input
                label="Data Fim"
                type="date"
                width="100%"
                class="pesquisa"
                name="DT_AGND_FIM"
                formControlName="DT_AGND_FIM"></app-input>
            </div>
          </form>
        </div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>
  <div class="mobile">
    <form [formGroup]="form" class="table-filters">
      <app-input
        label="Placa do Cavalo"
        placeholder="Pesquisar"
        name="TX_PLCA_CAVA"
        formControlName="TX_PLCA_CAVA"
        width="100%"></app-input>
      <app-input
        type="select-table"
        label="Tipo de Serviço"
        width="100%"
        name="FK_SRVC"
        formControlName="FK_SRVC"
        (ngModelChange)="escolherServico($event)"
        [selectData]="servicoOptions"></app-input>
      <app-input
        label="Data Início"
        type="date"
        width="100%"
        class="pesquisa"
        name="DT_AGND_INIC"
        formControlName="DT_AGND_INIC"></app-input>
      <app-input
        label="Data Fim"
        type="date"
        width="100%"
        class="pesquisa"
        name="DT_AGND_FIM"
        formControlName="DT_AGND_FIM"></app-input>
    </form>
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
  <app-subtitulo *ngIf="!tableData.length"
    >Nenhum registro encontrado.</app-subtitulo
  >
  <div class="paginacao">
    <app-paginacao
      *ngIf="tableData.length"
      [pages]="maxPages"
      (selectedPage)="mudarPagina($event)"></app-paginacao>
  </div>
  <div class="iframe-container"></div>
</app-layout>
